import React from 'react';
import {Button} from '@vkontakte/vkui';
import {Icon24ClockOutline} from '@vkontakte/icons';
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";

export function TournamentHistoryButton() {
    const routeNavigator = useRouteNavigator();

    const buttonHandler = () => {
        routeNavigator.push('/tournament-history');
    };

    return (
        <div className="flex w-full flex-col">
            <Button
                size="l"
                mode="primary"
                stretched
                onClick={buttonHandler}
                before={<Icon24ClockOutline/>}
                className="app-btn-primary"
            >
                История турниров
            </Button>
        </div>
    );
}
